import { LoadingButton } from "@mui/lab";
import { useTheme } from "@mui/material";

import { Strings } from "@app/constants";

import { SaveButtonsProps } from "../types";

const SaveButton = ({ onClick, loading }: SaveButtonsProps) => {
  const theme = useTheme();

  return (
    <LoadingButton
      onClick={onClick}
      variant="contained"
      sx={{
        backgroundColor: theme.palette.primary.main,
        px: 8,
        py: 1.5,
        fontWeight: 700,
        textTransform: "none",
        width: "42.5%",
        color: "white",
        fontFamily: "Work Sans",
      }}
      loading={loading}
    >
      {Strings.button.saveDetails}
    </LoadingButton>
  );
};

export { SaveButton };
